import { Button } from '@bambi/component-library/src/components/Button/Button';
import { CloudArrowDownIcon } from '@heroicons/react/24/outline';

import { VehicleInspectionReportDetailsRead } from 'src/common/external/bambi-api/bambiApi';
import { useModal } from 'src/common/modals/useModal';

import { VehicleInspectionsDownloadPDFReportModal } from '../VehicleInspectionsDownloadPDFReportModal';

export function ManageCell({
  inspection,
}: {
  inspection: VehicleInspectionReportDetailsRead;
}) {
  const { open, setOpen } = useModal();

  return (
    <>
      <Button
        dataTestId={`render-pdf-${inspection.id}`}
        variant="icon"
        ariaLabel={`Render PDF for inspection`}
        onClick={(e) => {
          // Stop the row from toggling
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <div
          className="flex flex-col items-center text-xs"
          style={{ fontSize: '0.625rem' }}
        >
          <CloudArrowDownIcon className="w-[24px]" />
          <span>Export</span>
        </div>
      </Button>
      <VehicleInspectionsDownloadPDFReportModal
        inspection={inspection}
        open={open}
        setOpen={setOpen}
      />
    </>
  );
}
